import { useDeviceType } from '../../../hooks/useDeviceType';
import { Text as Paragraph, Title } from '../../Typography';
import React from 'react';
import { IRatings } from './Ratings';

interface IHeading extends Pick<IRatings, 'ratingMsg' | 'ratingData'> {
  Rating: boolean;
  isRatingGiven: boolean;
}

export const Heading = ({ ratingMsg, isRatingGiven, Rating, ratingData }: IHeading) => {
  const { isMobile } = useDeviceType();
  return (
    <>
      {' '}
      <Paragraph className="mb-2.5 text-gray-500" tag="div" type="lead">
        {ratingMsg?.ratingSubtitle}
      </Paragraph>
      <Title className="md:block mb-2.5" tag="div" type={isMobile ? 'xxs' : 'sm'}>
        {Rating || isRatingGiven ? ratingMsg?.ratingThanks : ratingData.rating_title}
      </Title>
      <Paragraph className="md:text-base text-sm mb-5 text-gray-dark" tag="div" type="md">
        {Rating || isRatingGiven ? ratingMsg?.thanksMessage : ratingMsg?.ratingBody}
      </Paragraph>
    </>
  );
};
